export const IndexedDBConstants = {
    pidbRows: 'pidbRows',
    oldDocument: 'oldDocument'
}